'use strict';
var $String = String;

module.exports = function (argument) {
  try {
    return $String(argument);
  } catch (error) {
    return 'Object';
  }
};



//////////////////
// WEBPACK FOOTER
// ./~/handsontable/~/core-js/internals/try-to-string.js
// module id = 186
// module chunks = 0